import React, { Component } from "react"

class Footer extends Component {
    render() {
        return (
            <div id="footer">
                <footer id="footer">
                    <p className="copyright">&copy; Ivan Neto. All rights reserved. Design: <a href="https://html5up.net">HTML5 UP</a>.</p>
                </footer>
            </div>
        )
    }
}

export default Footer;
